import { useLingui } from "@lingui/react/macro";
import { Button, FormPhoneInput, type ServerError } from "@offstreetparking/design-system/forms";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useId } from "react";
import { useZod } from "../../providers/TranslationsProvider";
import { Form } from "../Form";
type SendSmsFormProps = {
	onSubmit: (phoneNumber: string) => void;
	isLoading: boolean;
	serverError?: ServerError;
};
export const SendSmsForm = ({ onSubmit, isLoading, serverError }: SendSmsFormProps) => {
	const { t } = useLingui();
	const z = useZod();
	const formId = useId();
	return (
		<div
			className="flex flex-col gap-4"
			ref={(node) => {
				if (node) {
					const input = node.querySelector<HTMLInputElement>("input[type='tel']");
					input?.focus();
				}
			}}
		>
			<Form
				serverError={serverError}
				id={formId}
				schema={z
					.object({
						phoneNumber: z.string().max(20),
					})
					.superRefine(({ phoneNumber }, ctx) => {
						if (!phoneNumber?.trim()) {
							ctx.addIssue({
								code: "custom",
								path: ["phoneNumber"],
								message: t`Please enter your phone number`,
							});
							return;
						}

						if (!isValidPhoneNumber(phoneNumber)) {
							ctx.addIssue({
								code: "custom",
								path: ["phoneNumber"],
								message: t`Enter a valid phone number`,
							});
						}
					})}
				initialValues={{
					phoneNumber: "",
				}}
				onSubmit={({ phoneNumber }) => onSubmit(phoneNumber)}
			>
				{({ formState: { errors } }) => {
					return (
						<>
							<div className="mb-2 space-y-4">
								<FormPhoneInput
									name="phoneNumber"
									label={t`Phone Number`}
									error={errors.phoneNumber?.message}
									defaultCountry={"US"}
									isRequired
								/>
							</div>

							<Button
								size="md"
								className="mt-4 w-full p-4 font-bold"
								isLoading={isLoading}
								intent="primary"
							>
								{t`Schedule`}
							</Button>
						</>
					);
				}}
			</Form>
		</div>
	);
};
